<div class="container container-fluid">
    <div class="text-left content">
        <div class="container-fluid">
            <div class="text-left content">
              <h2>{{titleText}}</h2>
              <p [innerHTML]="mainText"></p>
            </div>
        </div>

        <br />
        <div class="container" ngSwitch="{{productSelected}}">
            <div *ngSwitchCase="'adb'">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center unsuccessful">
                <a class="phone-btn btn-primary btn-huge"  href="https://www.fidelitylife.com"><span>FIDELITYLIFE.COM</span></a>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center unsuccessful">
                <a class="phone-btn btn-secondary btn-huge"  href="tel:{{contactNumber}}"><span>Call 1-{{contactNumber}}</span></a>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center unsuccessful" *ngSwitchDefault>
                <a class="phone-btn btn-primary btn-huge"  href="tel:{{contactNumber}}"><span>Call 1-{{contactNumber}}</span></a>
            </div>
        </div>
    </div>
</div>
